import ArtistSearchBaseController from "./artist_search_base"

export default class extends ArtistSearchBaseController {
  // Implementation of abstract methods from base class
  getCallingControllerType() {
    return "featuring"
  }

  getHiddenInputName() {
    return "album[featuring_artist_ids][]"
  }

  getHiddenInputId(artistId) {
    return `featuring_artist_${artistId}`
  }
}